import '@fortawesome/fontawesome-pro/css/all.min.css';
import { HeaderBar } from 'components/city-blocks/header-bar';
import { Footer } from 'components/footer/footer';
import Head from 'next/head';

function Layout({ children }) {
  return (
    <div>
      <Head>
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <link rel='icon' href='/favicon.ico' />
        <link rel='icon' type='image/png' sizes='57x57' href='/favicon-57x57.png' />

        <title></title>
      </Head>
      <main className='flex w-full flex-col'>
        <HeaderBar />
        {children}
        <Footer className='mt-4 md:mt-20' />
      </main>
    </div>
  );
}

export default Layout;
